<template>
  <div>
    <div style="height: 36px;margin-bottom: 10px">
      <el-button type="primary" size="medium" style="font-size: 12px;" @click="handleInfo2()">添加
      </el-button>
    </div>
    <!-- 表格部分 -->
    <el-table :data="loanTable" size="mini" border style="width: 100%" v-loading="loading">
      <el-table-column
          header-align="center"
          align="center"
          fixed
          prop="app_type"
          label="类型"
          min-width="80"
      ></el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="sort_no"
          label="排序"
          min-width="120"
      ></el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          label="图片"
          min-width="120">
        <template slot-scope="scope">
          <el-image :src="scope.row.image_url" class="elImage"></el-image>
        </template>
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="image_title"
          label="名称"
          min-width="120"
      ></el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="creator"
          label="创建人"
          min-width="120"
      ></el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="create_time"
          label="创建时间"
          min-width="120"
      ></el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          label="操作"
          min-width="120"
      >
        <template slot-scope="scope">
          <el-button type="text" style="color: blue" @click="handleInfo(scope.row)">编辑</el-button>
          <el-button type="text" style="color: red" @click="deleteInfo(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--编辑、添加表单-->
    <el-dialog v-if="dialogVisible" title="配置表单" :visible.sync="dialogVisible" :before-close="handleClose">
      <el-form :model="submitData" :rules="rules" ref="ruleForm">
        <el-form-item label="类型" prop="app_type" :label-width="formLabelWidth">
          <el-radio-group v-model="submitData.app_type">
            <el-radio v-model="submitData.app_type" label="10">首页</el-radio>
            <el-radio v-model="submitData.app_type" label="20">商学院</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="名称" :label-width="formLabelWidth" prop="image_title" style="margin-bottom: 17px">
          <el-input v-model="submitData.image_title" autocomplete="off" placeholder="请输入名称"></el-input>
        </el-form-item>
        <el-form-item label="排序" :label-width="formLabelWidth" prop="sort_no" style="margin-bottom: 17px">
          <el-input v-model="submitData.sort_no" autocomplete="off"
                    placeholder="请输入排序"></el-input>
        </el-form-item>
        <el-form-item label="banner图片" :label-width="formLabelWidth" prop="image_url"
                      style="margin-bottom: 17px">
          <el-upload
              ref="uploads"
              class="avatar-uploader "
              :action="uploadImgUrl"
              list-type="picture-card"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
              :on-error="handleUploadError"
              :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove"
              :headers="headers"
              :show-file-list="true"
              :file-list="fileList"
              style="width: 500px"
          >
            <i class="el-icon-plus avatar-uploader-icon"></i>
            <div slot="tip" class="el-upload__tip">请上传图片</div>
          </el-upload>
          <el-dialog :visible.sync="dialogVisibleImg123" append-to-body>
            <div class="demo-image__preview">
              <el-image width="100%" :src="logoUrl" alt=""></el-image>
            </div>
          </el-dialog>
        </el-form-item>
        <el-form-item label="链接地址" :label-width="formLabelWidth" style="margin-bottom: 17px">
          <el-input v-model="submitData.image_href" autocomplete="off" placeholder="请输入链接地址"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose()">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: "rotationChartManagement",
  data() {
    return {
      loanTable: [], //列表
      loading: true, //列表loadding
      dialogVisible: false,//编辑表单页面显示
      formLabelWidth: '120px',
      dialogData: {},//
      submitData: {//表单请求数据
        id: '',//id
        app_type: '',//‘10首页，20商学院’
        client_type: '',//
        image_title: '',//图片标题
        image_url: '',//图片地址
        image_href: '',//链接地址
        sort_no: '',//排序
        enable_status: '',//
        creator: '',//创建人
        create_time: '',//创建人时间
        modifier: '',//修改人
        modify_time: '',//修改人时间
        rec_status: ''//
      },
      rules: {
        image_title: [
          {required: true, message: '请输入名称', trigger: 'blur'},
        ],
        sort_no: [
          {required: true, message: '请输入排序', trigger: 'blur'}
        ],
        app_type: [
          {required: true, message: '请输入类型', trigger: 'blur'}
        ],
        image_url: [
          {required: true, message: '请上传图片', trigger: 'blur'}
        ],
      },
      headers: {  // 请求头部参数
        token: sessionStorage.getItem('token')
      },
      logoUrl: "",//上传的图片地址
      uploadImgUrl: "/api/system/uploadFile", // 上传图片的后台controller的地址
      dialogVisibleImg123: false,
      fileList: []
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    handleAvatarSuccess(res) {
      this.logoUrl = res.data.url;
      this.submitData.image_url = this.logoUrl;
      this.fileList = [];
      this.fileList.push(
          {
            name: '',
            url: this.logoUrl
          }
      );
      this.$message({
        message: '图片上传成功',
        type: 'success'
      });
    },
    beforeAvatarUpload(file) {
      if (this.logoUrl != '') {
        this.$message({
          type: 'warning',
          message: '当前限制选择 1 个文件，本次选择了 1 个文件，共选择了 2 个文件',
          duration: 1000,
        });
        return false;
      }
      // const isJPG = file.type === 'image/jpeg';
      // const isLt20M = file.size / 1024 / 1024 < 20;
      //
      // if (!isJPG) {
      //     this.$message.error('上传头像图片只能是 JPG 格式!');
      // }
      // if (!isLt20M) {
      //     this.$message.error('上传头像图片大小不能超过 20MB!');
      // }
      // return isJPG && isLt20M;
    },
    handleUploadError() {
      this.$message({
        type: "error",
        message: "上传失败",
      });
    },
    handleRemove(file) {
      this.logoUrl = '';
      this.submitData.image_url = '';
      this.fileList[0].url = '';
    },
    handlePictureCardPreview(file) {
      this.dialogVisibleImg123 = true;
    },
//监听弹出层隐藏
    handleClose() {
      this.$nextTick(() => {
        this.submitData = {}
        this.$refs.uploads.clearFiles() //清除上传文件对象
        this.fileList = [] //清空选择的文件列表
      })
      this.dialogVisible = false;
    },
    // 编辑表单显示
    handleInfo(row) {
      this.fileList = [];
      this.dialogData = JSON.parse(JSON.stringify(row));
      this.submitData.app_type = this.dialogData.app_type.value;
      this.submitData.id = this.dialogData.id;
      this.submitData.client_type = this.dialogData.client_type;
      this.submitData.creator = this.dialogData.creator;
      this.submitData.sort_no = this.dialogData.sort_no;
      this.submitData.create_time = this.dialogData.create;
      this.submitData.enable_status = this.dialogData.enable_status;
      this.submitData.image_href = this.dialogData.image_href;
      this.submitData.image_title = this.dialogData.image_title;
      this.submitData.image_url = this.dialogData.image_url;
      this.submitData.modifier = this.dialogData.modifier;
      this.submitData.modify_time = this.dialogData.modify_time;
      this.submitData.rec_status = this.dialogData.rec_status;
      this.logoUrl = this.submitData.image_url;
      this.fileList.push({
        name: '',
        url: this.submitData.image_url
      });
      this.dialogVisible = true;
    },
    // 添加表单显示
    handleInfo2() {
      this.dialogVisible = true;
      // this.submitData = {};
      this.logoUrl = '';
    },
    // 删除
    deleteInfo(row) {
      this.$confirm('确定要删除吗？', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$api.post("/api/system/bannerDelete", {id: row.id}, res => {
          if (res.status == 200) {
            this.$message({
              type: 'success',
              message: '删除成功',
              duration: 1000,
            });
            this.getData();
          } else {
            this.$message.error(res.msg);
          }
        })
      })
    },
    // 表单校验
    submitForm(formName) {
      console.log(this.submitData)
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 编辑确定
          this.$api.post("/api/system/bannerForm", this.submitData, res => {
            if (res.status == 200) {
              this.$message({
                type: 'success',
                message: '操作成功',
                duration: 1000,
              });
              this.submitData = {
                app_type: '',//‘10首页，20商学院’
                client_type: '',//
                image_title: '',//图片标题
                image_url: '',//图片地址
                image_href: '',//链接地址
                sort_no: '',//排序
                enable_status: '',//
                creator: '',//创建人
                create_time: '',//创建人时间
                modifier: '',//修改人
                modify_time: '',//修改人时间
                rec_status: ''//
              }
              this.$refs.uploads.clearFiles() //清除上传文件对象
              this.fileList = [] //清空选择的文件列表
              this.dialogVisible = false;
              this.getData();
            } else {
              this.$message.error(res.msg);
            }
          })
        } else {
          return false;
        }
      });
    },
    // 页面显示
    getData() {
      this.$api.post("/api/system/bannerList", {}, res => {
        this.loanTable = res.data;
        //渲染结束后取消加载
        this.loading = false;
      })
    },
  }
}
</script>

<style scoped>
.elImage {
  width: 100px;
  height: 35px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 148px;
  height: 148px;
  line-height: 148px;
  text-align: center;
}

.avatar {
  width: 148px;
  height: 148px;
  display: block;
}
</style>
